import { render } from "./InvoiceHeader.vue?vue&type=template&id=aba389f4&ts=true"
import script from "./InvoiceHeader.vue?vue&type=script&lang=ts"
export * from "./InvoiceHeader.vue?vue&type=script&lang=ts"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__